import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import { useMemo } from 'react';
import { TIMEZONE } from '../../../shared/constants';
import { FORMAT_LLLL, FORMAT_LT } from '../constants/misc';

dayjs.extend(timezone);

export function useFormattedDateTime(isoString) {
  return useMemo(() => {
    const t = dayjs.tz(isoString, TIMEZONE);
    const formattedDate = t.format(FORMAT_LLLL);
    const formattedTime = t.format(FORMAT_LT);
    return { t, formattedDate, formattedTime };
  }, [isoString]);
}
